<template>
  <v-toolbar dense :color="$store.state.sysBackgroundColor">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon @click="ejecutarAccion('Cerrar')" v-on="on">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </template>
      <span>Volver</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <v-toolbar-title class="overline">{{ titulo }}</v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
export default {
  name: "EncabezadoVacio",
  props: {
    titulo: String
  },
  data() {
    return {
      activo: false
    };
  },
  methods: {
    ejecutarAccion(accion) {
      if (accion == "Cerrar") this.$router.go(-1);
    }
  }
};
</script>
